import { Link } from "react-router-dom";
import { MenuItem } from "./styles";

interface INavProps {
  children: React.ReactNode;
  to: string;
  category: string;
  isExternal?: boolean; // Add isExternal prop
}

export const NavItem = ({ children, to, category, isExternal }: INavProps) => {
  if (isExternal) {
    // Render an external link
    return (
      <MenuItem>
        <a href={to} target="_blank" rel="noopener noreferrer">
          {children}
        </a>
      </MenuItem>
    );
  }

  // Append the category as a query parameter to the URL for internal links
  const urlWithCategory = `${to}?category=${category}`;

  return (
    <MenuItem>
      <Link to={urlWithCategory}>{children}</Link>
    </MenuItem>
  );
};
